<template>
  <div class="apply-detail">
    <div class="title">
      <div class="label">申请信息</div>
      <div class="content">
        <img
          v-if="detail.status"
          :src="icons[detail.status]"
          alt=""
          style="width: 54px; height: 51px"
        />
      </div>
    </div>
    <div class="item">
      <div class="label">请假学生：</div>
      <div class="content">
        {{ detail.periodName }}{{ detail.className }} {{ detail.studentName }}
      </div>
    </div>

    <div class="item">
      <div class="label">请假类型：</div>
      <div class="content">{{ detail.typeName }}</div>
    </div>

    <div class="item">
      <div class="label">开始时间：</div>
      <div class="content">{{ detail.startTime }}</div>
    </div>

    <div class="item">
      <div class="label">结束时间：</div>
      <div class="content">{{ detail.endTime }}</div>
    </div>

    <div class="item">
      <div class="label">请假时长：</div>
      <div class="content">{{ detail.duration }}</div>
    </div>

    <div class="item">
      <div class="label">请假原因：</div>
      <div class="content">{{ detail.reason }}</div>
    </div>
    <div class="item">
      <div class="label">图片：</div>
      <div class="content" style="overflow-x: auto">
        <img
          style="width: 28px; height: 28px; margin-left: 4px"
          :key="file.id"
          v-for="(file, index) in detail.fileList"
          :src="file.ossUrl"
          @click="priviewPic(index)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { toRefs } from "vue";
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    icons: {
      type: Object,
      default() {
        return {
          underway: require("@/assets/image/studentLeave/shenpizhong.png"),
          agree: require("@/assets/image/studentLeave/tongyi.png"),
          refuse: require("@/assets/image/studentLeave/jujue.png"),
          revoke: require("@/assets/image/studentLeave/chexiao.png"),
          finish: require("@/assets/image/studentLeave/xiaojia.png"),
        };
      },
    },
  },
  setup(props) {
    let { detail } = toRefs(props);
    const priviewPic = (index) => {
      let list = [];

      if (
        detail.value &&
        detail.value.fileList &&
        detail.value.fileList.length
      ) {
        detail.value.fileList.map((file) => {
          if (file && file.id) {
            list.push(file.ossUrl);
          }
        });
      }

      if (list && list.length) {
        ImagePreview({
          images: list,
          startPosition: index,
          closeable: true,
        });
      }
    };
    return {
      priviewPic,
    };
  },
};
</script>

<style lang="less" scoped>
.apply-detail {
  font-size: 15px;
  font-weight: 400;
  padding: 12px;
  border-radius: 8px;
  background-color: #fff;
  .title {
    display: flex;
    height: 44px;
    margin-bottom: 12px;
    padding: 10px 0;
    padding-top: 0;
    .label {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .content {
      flex: 2;
      text-align: right;
    }
  }
  .item {
    display: flex;
    height: 44px;
    .label {
      flex: 1;
      color: #666;
    }
    .content {
      flex: 2;
      text-align: right;
      color: #333;
    }
  }
}
</style>
